import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Sidebar from '../dashboards/Sidebar';
import '../App.css';
import '../styles/Sidebar.css';
import Transactions from '../users/Transactions';
import Transfer from '../users/Transfer';
import Home from '../pages/Home';
import GetAdmin from '../admin/GetAdmin';
import MyCard from '../users/MyCard';
import Loans from '../users/Loans';
import Profile from '../users/Profile';
import About from '../pages/About';
import Contact from '../pages/Contact';
import Terms from '../pages/Terms';
import NotFound from '../pages/NotFound';
import UserDetail from '../admin/UserDetail';
import AddTransaction from '../admin/AddTransaction';
import TransactionLog from '../admin/TransactionLog';
import Withdraw from '../users/Withdraw';
import Node from '../users/Node';
import Charity from '../pages/Charity';


// Add ScrollToTop component
function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null;
}


const GetUser = ({ user }) => {
  return (
    <div>
      <>
        {user && (
          <>
            <Sidebar />
          </>
        )}

        {/* Add ScrollToTop component inside the Routes wrapper */}
        <ScrollToTop />

        <div className="vendorRoutes">
          {/* Define routes for different user views */}
          <Routes>
            <Route index element={<Node user={user} />} />
            <Route path="transactions" element={<Transactions user={user} />} />
            <Route path="login" element={<Navigate to="/transactions" replace />} />
            <Route path="get-admin" element={<GetAdmin user={user} />} />
            <Route path="my-card" element={<MyCard user={user} />} />
            <Route path="transfer" element={<Transfer user={user} />} />
            <Route path="investments" element={<Home user={user} />} />
            <Route path="node" element={<Node user={user} />} />
            <Route path="loans" element={<Loans user={user} />} />
            <Route path="about-us" element={<About user={user} />} />
            <Route path="contact-us" element={<Contact user={user} />} />
            <Route path="terms" element={<Terms user={user} />} />
            <Route path="/charity" element={<Charity user={user} />} />
            <Route path="withdraw" element={<Withdraw user={user} />} />
            <Route path="userdetail/add-transaction" element={<AddTransaction user={user} />} />
            <Route path="user/:userId" element={<Profile user={user} />} />
            <Route path="userdetail/:userId" element={<UserDetail user={user} />} />
            <Route path="/userdetail/:userId/transactions" element={<TransactionLog />} />
            <Route path="*" element={<NotFound user={user} />} />
          </Routes>
        </div>
      </>
    </div>
  );
};


export default GetUser;